import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/pro-light-svg-icons'

import { Box } from '@domain-group/suit-theme'

interface OverlayBoxProps {
  backgroundColor: string,
  icon: IconDefinition,
}

const OverlayBox = (props: OverlayBoxProps) => {
  const {
    backgroundColor, icon,
  } = props

  return (
    <Box
      alignItems="center"
      backgroundColor={backgroundColor}
      borderRadius={5}
      color="white"
      height="28px"
      justifyContent="center"
      marginRight="small"
      marginTop="small"
      width="28px"
    >
      <FontAwesomeIcon icon={icon} />
    </Box>
  )
}

export default OverlayBox
